import { FC } from 'react';
import './StreamlineComponent.scss';
import { STREAMLINE_LABELS } from './model';
import { ButtonComponent } from '../../UI/ButtonComponent/ButtonComponent';
import { VideoVimeoComponent } from '../../UI/VideoVimeoComponent/VideoVimeoComponent';

const StreamlineComponent: FC = () => {
	const handleNavigate = () => {
		// Pending to check interaction
	};
	return (
		<div className='streamline-container'>
			<h2 className='section-title'>{STREAMLINE_LABELS.title}</h2>
			<p className='section-content'>{STREAMLINE_LABELS.section1}</p>
			<div className='video-mask'>
				<VideoVimeoComponent
					autoplay
					videoId={STREAMLINE_LABELS.videoLink}
					hash={STREAMLINE_LABELS.videoHash}
					videoTitle='Beacon Discovery - Anytime, Anywhere Product Discovery'
				></VideoVimeoComponent>
			</div>
			<p className='section-content'>{STREAMLINE_LABELS.section2}</p>
			<ButtonComponent
				text={STREAMLINE_LABELS.buttonText}
				onClick={handleNavigate}
				style='rounded-button primary'
				icon={<i className='ri-arrow-right-s-line line-icon'></i>}
			/>
		</div>
	);
};

export default StreamlineComponent;
